import axios from 'axios';

export const API = axios.create({
    baseURL: `https://api-alerta.rolante.ifrs.edu.br/api`,
  // baseURL: `http://127.0.0.1:5000/api`,
});

